module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://shadow.zhaogangimg.com/assets/zgkaihu/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 147);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.regexp.exec");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.symbol");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.keys");

/***/ }),

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "core-js/modules/es.function.name"
var es_function_name_ = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/account-withdraw/src/main.vue?vue&type=template&id=5a4004b5&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "zg-kh-account-withdraw" },
    [
      _c("div", { staticClass: "withdraw-title" }, [
        _vm._v("提现至绑定的结算账户")
      ]),
      _c("div", { staticClass: "main-container" }, [
        _c("div", { staticClass: "item-group" }, [
          _c("div", { staticClass: "label" }, [_vm._v("账户名称")]),
          _c("div", { staticClass: "value" }, [
            _vm._v(_vm._s(_vm.channel.companyName))
          ])
        ]),
        _c("div", { staticClass: "item-group" }, [
          _c("div", { staticClass: "label" }, [_vm._v("银行账号")]),
          _c("div", { staticClass: "value" }, [
            _c("div", { staticClass: "bank-info" }, [
              _c("div", { staticClass: "bank-no" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.channel.bindSettleBankName) +
                    "\n            "
                ),
                _c("span", { staticClass: "m-l4" }, [
                  _vm._v(
                    _vm._s(_vm._f("bankNoformat")(_vm.channel.bindSettleAccNo))
                  )
                ])
              ]),
              _c("div", { staticClass: "bank-name" }, [
                _vm._v(_vm._s(_vm.channel.bindSettleBankBranchName))
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "item-group" }, [
          _c("div", { staticClass: "label" }, [_vm._v("可提现金额")]),
          _c("div", { staticClass: "value" }, [
            _c("span", { staticClass: "withdrawable-amount" }, [
              _vm._v(
                "¥ " +
                  _vm._s(_vm._f("formatMoneyCent")(_vm.channel.usableAmount))
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "item-group item-withdraw-group" }, [
          _c("div", { staticClass: "label" }, [_vm._v("提现金额")]),
          _c("div", { staticClass: "value" }, [
            _c("div", { staticClass: "withdraw-input-group" }, [
              _c("span", { staticClass: "money-sep" }, [_vm._v("¥")]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.realWithdrawAmount,
                    expression: "realWithdrawAmount"
                  }
                ],
                staticClass: "real-withdraw-amount",
                attrs: { type: "text" },
                domProps: { value: _vm.realWithdrawAmount },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.realWithdrawAmount = $event.target.value
                    },
                    _vm.only2Decimal
                  ]
                }
              }),
              _c(
                "span",
                { staticClass: "pick-all-btn", on: { click: _vm.pickAll } },
                [_vm._v("全部提现")]
              )
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.realWithdrawAmount > 0,
                    expression: "realWithdrawAmount > 0"
                  }
                ],
                staticClass: "upper-money-desc"
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("formatAmountCapitalized")(_vm.realWithdrawAmount)
                    ) +
                    "\n        "
                )
              ]
            )
          ])
        ]),
        _c("div", { staticClass: "item-group item-remark" }, [
          _c("div", { staticClass: "label" }, [_vm._v("备注")]),
          _c(
            "div",
            { staticClass: "value" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: _vm.remarkMaxLength,
                  rows: 6,
                  placeholder: "请输入提现摘要/备注信息"
                },
                model: {
                  value: _vm.remark,
                  callback: function($$v) {
                    _vm.remark = $$v
                  },
                  expression: "remark"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "item-group" }, [
          _c("div", { staticClass: "label" }),
          _c(
            "div",
            { staticClass: "value" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "90px", height: "36px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.preCheck }
                },
                [_vm._v("提现")]
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.estimatedTime,
                      expression: "estimatedTime"
                    }
                  ],
                  staticClass: "m-l20 f-15"
                },
                [
                  _c("span", [_vm._v("预计")]),
                  _c("span", { staticClass: "c-main" }, [
                    _vm._v(_vm._s(_vm.estimatedTime))
                  ]),
                  _c("span", [_vm._v("到账")])
                ]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          { staticClass: "explain" },
          [
            _c("div", { staticClass: "tip-title" }, [
              _vm._v("\n        到账说明：\n      ")
            ]),
            _vm.accType === 2
              ? [
                  _c("div", { staticClass: "tip-content" }, [
                    _vm._v(
                      "\n          工作日：上午 9 点至下午 17 点：金额 ＜ 5 万元预计半小时内到账；金额 ≥ 5 万元预计两小时内到账。下午 17\n          点至次日上午 9 点：金额 ＞ 5 万元下一个工作日到账；金额 ≤ 5 万元预计两小时内到账。\n        "
                    )
                  ]),
                  _c("div", { staticClass: "tip-content" }, [
                    _vm._v(
                      "非工作日：金额 ＞ 50 万元下一个工作日到账；金额 ≤ 50 万元预计两小时内到账。"
                    )
                  ])
                ]
              : [
                  _c("div", { staticClass: "tip-content" }, [
                    _vm._v(
                      "\n          工作日：前一日晚上 8点半 至 当日 17点半：金额 ＜ 5 万元预计半小时内到账；金额 ≥ 5\n          万元预计两小时内到账。当日下午 17点半 至 当日晚上 20点半：金额 ＞ 5 万元下一个工作日到账；金额 ≤ 5\n          万元预计两小时内到账。\n        "
                    )
                  ]),
                  _c("div", { staticClass: "tip-content" }, [
                    _vm._v(
                      "非工作日： 金额 ＞ 5 万元下一个工作日到账；金额 ≤ 5万元预计两小时内到账。"
                    )
                  ])
                ]
          ],
          2
        )
      ]),
      _c("kaihu-sms-code", {
        ref: "smsCode",
        attrs: { maxlength: 6, visible: _vm.sms.visible, desc: _vm.sms.desc },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sms, "visible", $event)
          },
          reset: _vm.sendSmsCode,
          finished: _vm.smsHandleCodeFinished
        }
      }),
      _c("cft-scan-dialog", {
        attrs: {
          visible: _vm.cftScan.visible,
          "qr-code-info": _vm.cftScan.qrCodeInfo
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cftScan, "visible", $event)
          },
          closeHandler: _vm.cftScanCloseHandler,
          cftScanTenpayInitFail: _vm.cftScanTenpayInitFail
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/account-withdraw/src/main.vue?vue&type=template&id=5a4004b5&

// EXTERNAL MODULE: external "core-js/modules/es.symbol"
var es_symbol_ = __webpack_require__(12);

// EXTERNAL MODULE: external "core-js/modules/es.array.filter"
var es_array_filter_ = __webpack_require__(15);

// EXTERNAL MODULE: external "core-js/modules/es.array.for-each"
var es_array_for_each_ = __webpack_require__(8);

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptor"
var es_object_get_own_property_descriptor_ = __webpack_require__(26);

// EXTERNAL MODULE: external "core-js/modules/es.object.get-own-property-descriptors"
var es_object_get_own_property_descriptors_ = __webpack_require__(27);

// EXTERNAL MODULE: external "core-js/modules/es.object.keys"
var es_object_keys_ = __webpack_require__(13);

// EXTERNAL MODULE: external "core-js/modules/es.parse-float"
var es_parse_float_ = __webpack_require__(99);

// EXTERNAL MODULE: external "core-js/modules/es.regexp.exec"
var es_regexp_exec_ = __webpack_require__(11);

// EXTERNAL MODULE: external "core-js/modules/es.string.replace"
var es_string_replace_ = __webpack_require__(21);

// EXTERNAL MODULE: external "core-js/modules/web.dom-collections.for-each"
var web_dom_collections_for_each_ = __webpack_require__(9);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(2);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// EXTERNAL MODULE: external "regenerator-runtime/runtime"
var runtime_ = __webpack_require__(7);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(1);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "zgkaihu/lib/kaihu-sms-code"
var kaihu_sms_code_ = __webpack_require__(25);
var kaihu_sms_code_default = /*#__PURE__*/__webpack_require__.n(kaihu_sms_code_);

// EXTERNAL MODULE: external "zgkaihu/lib/cft-scan-dialog"
var cft_scan_dialog_ = __webpack_require__(55);
var cft_scan_dialog_default = /*#__PURE__*/__webpack_require__.n(cft_scan_dialog_);

// EXTERNAL MODULE: external "number-precision"
var external_number_precision_ = __webpack_require__(33);
var external_number_precision_default = /*#__PURE__*/__webpack_require__.n(external_number_precision_);

// EXTERNAL MODULE: external "zgkaihu/lib/utils/debounce"
var debounce_ = __webpack_require__(40);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// EXTERNAL MODULE: external "zgkaihu/lib/utils/filters"
var filters_ = __webpack_require__(4);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/account-withdraw/src/main.vue?vue&type=script&lang=js&














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty_default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




external_number_precision_default.a.enableBoundaryChecking(false);

var WithDrawVerifyCodeType = 'ACC_ELE_WITHDRAW'; //动态验证码类型：账户提现

var DefaultDesc = '验证码已发至%s，有效期10分钟。';
/* harmony default export */ var mainvue_type_script_lang_js_ = ({
  name: 'ZgKhAccountWithdraw',
  components: {
    KaihuSmsCode: kaihu_sms_code_default.a,
    CftScanDialog: cft_scan_dialog_default.a
  },
  filters: {
    formatMoneyCent: filters_["formatMoneyCent"],
    formatAmountCapitalized: filters_["formatAmountCapitalized"],
    bankNoformat: filters_["bankNoformat"]
  },
  props: {
    accCenterRouterName: {
      type: String,
      name: null
    }
  },
  data: function data() {
    return {
      channel: {},
      realWithdrawAmount: '',
      remark: '',
      accTradeId: '',
      //提现申请id
      sms: {
        visible: false,
        desc: ''
      },
      cftScan: {
        visible: false,
        qrCodeInfo: {},
        timer: 0
      },
      errorTimer: null,
      //提现预计到账时间
      estimatedTime: '',
      debounceCalcEstimatedTime: null
    };
  },
  computed: {
    /**账户ID,即为账户主键ID */
    accId: function accId() {
      var _this$$route$query$ac = this.$route.query.accId,
          accId = _this$$route$query$ac === void 0 ? 0 : _this$$route$query$ac;
      return accId;
    },

    /**可提现金额 单位分 */
    usableAmount: function usableAmount() {
      return external_number_precision_default.a.divide(this.channel.usableAmount, 100);
    },

    /**当前支付类型 2:招行 5:财付通 */
    accType: function accType() {
      return this.channel.accType;
    },
    remarkMaxLength: function remarkMaxLength() {
      return 15;
    }
  },
  mounted: function mounted() {
    var _this = this;

    //TODO cmb备注可以不填，财付通备注必填
    if (!this.accId) {
      this.$message.error('参数错误，3秒后将自动返回首页');
      this.errorTimer = setTimeout(function () {
        _this.accCenterRouterName && _this.$router.replace({
          name: _this.accCenterRouterName
        });
      }, 3000);
      return false;
    }

    this.requestAccountInfo();
    this.debounceCalcEstimatedTime = debounce_default()(300, this.calcEstimatedTime);
  },
  beforeDestroy: function beforeDestroy() {
    this.errorTimer && clearTimeout(this.errorTimer);
    this.cftScanLoopClear();
  },
  methods: {
    //全部提现
    pickAll: function pickAll() {
      this.realWithdrawAmount = this.usableAmount;
      this.only2Decimal();
    },
    // 限制输入金额大于 0 且最多 2 位小数
    only2Decimal: function only2Decimal() {
      try {
        var price = this.realWithdrawAmount + '';
        price = price.replace(/[^\d.]/g, '');
        price = price.replace(/^\./g, '');
        price = price.replace(/\.{2,}/g, '.');
        price = price.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        price = price.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
        this.realWithdrawAmount = price > this.usableAmount ? this.usableAmount : price;
      } catch (e) {
        this.realWithdrawAmount = 0;
      }

      this.debounceCalcEstimatedTime && this.debounceCalcEstimatedTime();
    },
    //计算预计到账时间
    calcEstimatedTime: function calcEstimatedTime() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var resp, _this2$$zgKaihu$$conv, success, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (_this2.realWithdrawAmount) {
                  _context.next = 4;
                  break;
                }

                _this2.estimatedTime = '';
                return _context.abrupt("return");

              case 4:
                _context.next = 6;
                return _this2.$zgKaihu.$get('paycore.getWithdrawArriveTime', {
                  accId: _this2.accId,
                  amount: external_number_precision_default.a.times(parseFloat(_this2.realWithdrawAmount), 100),
                  ignoreErrCodes: ['all']
                }, {
                  notNeedLoading: true,
                  ignoreErrCodes: ['all']
                });

              case 6:
                resp = _context.sent;
                _this2$$zgKaihu$$conv = _this2.$zgKaihu.$convertResp(resp), success = _this2$$zgKaihu$$conv.success, data = _this2$$zgKaihu$$conv.data;

                if (success && data && data.success) {
                  _this2.estimatedTime = data.arriveTime;
                } else {
                  _this2.estimatedTime = '';
                }

                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);
                console.log(_context.t0);
                _this2.estimatedTime = '';

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 11]]);
      }))();
    },
    //获取当前账户信息
    requestAccountInfo: function requestAccountInfo() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var resp, _this3$$zgKaihu$$conv, success, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.$zgKaihu.$get('paycore.service.getSingleAccDetail', {
                  accId: _this3.accId
                });

              case 2:
                resp = _context2.sent;
                _this3$$zgKaihu$$conv = _this3.$zgKaihu.$convertResp(resp), success = _this3$$zgKaihu$$conv.success, data = _this3$$zgKaihu$$conv.data;

                if (success) {
                  _this3.channel = _objectSpread({
                    companyName: data.companyName
                  }, data.accDetailVO);
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    //点击提现
    preCheck: function preCheck() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this4.realWithdrawAmount <= 0)) {
                  _context3.next = 3;
                  break;
                }

                _this4.$message.error('请输入正确的提现金额（最小为 0.01 元）');

                return _context3.abrupt("return");

              case 3:
                if (!(_this4.realWithdrawAmount > _this4.usableAmount)) {
                  _context3.next = 6;
                  break;
                }

                _this4.$message.error('提现金额不能超过可提现金额');

                return _context3.abrupt("return");

              case 6:
                if (!(_this4.channel.accType === 5 && !_this4.remark)) {
                  _context3.next = 9;
                  break;
                }

                _this4.$message.error('请输入备注信息');

                return _context3.abrupt("return");

              case 9:
                _this4.sendSmsCode();

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    //计算预计到账时间
    //弹出 获取验证码对话框
    sendSmsCode: function sendSmsCode() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var queryParams, resp, _this5$$zgKaihu$$conv, success, data, _this5$channel$agent, agent;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                queryParams = {
                  accountId: _this5.accId,
                  verifyCodeType: WithDrawVerifyCodeType
                };
                _context4.next = 3;
                return _this5.$zgKaihu.$get('paycore.sendVerifyCode', {
                  param: queryParams
                });

              case 3:
                resp = _context4.sent;
                _this5$$zgKaihu$$conv = _this5.$zgKaihu.$convertResp(resp), success = _this5$$zgKaihu$$conv.success, data = _this5$$zgKaihu$$conv.data;

                if (success) {
                  if (_this5.sms.visible) {
                    _this5.$refs.smsCode.resetCountDown();
                  } else {
                    _this5$channel$agent = _this5.channel.agent, agent = _this5$channel$agent === void 0 ? {
                      phone: ''
                    } : _this5$channel$agent;
                    _this5.sms.desc = DefaultDesc.replace('%s', agent.phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'));
                    _this5.sms.visible = true;
                  }
                }

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    //验证码校验成功
    smsHandleCodeFinished: function smsHandleCodeFinished(code) {
      var _this6 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var params, resp, _this6$$zgKaihu$$conv, success, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  accountId: _this6.accId,
                  verifyCodeType: WithDrawVerifyCodeType,
                  verifyCode: code
                };
                _context5.next = 3;
                return _this6.$zgKaihu.$post('paycore.checkVerifyCode', {
                  param: params
                });

              case 3:
                resp = _context5.sent;
                _this6$$zgKaihu$$conv = _this6.$zgKaihu.$convertResp(resp), success = _this6$$zgKaihu$$conv.success, data = _this6$$zgKaihu$$conv.data;

                if (!(success && data.success)) {
                  _context5.next = 8;
                  break;
                }

                _context5.next = 8;
                return _this6.confirmWithdraw();

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 提交提现申请
    confirmWithdraw: function confirmWithdraw() {
      var _this7 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var withdrawParam, resp, _this7$$zgKaihu$$conv, success, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // 接口需要的金额，单位是分
                withdrawParam = {
                  accId: _this7.accId,
                  accType: _this7.accType,
                  subject: _this7.remark,
                  withdrawAmount: external_number_precision_default.a.times(parseFloat(_this7.realWithdrawAmount), 100)
                };
                _context6.next = 3;
                return _this7.$zgKaihu.$get('paycore.withdraw', {
                  withdrawParam: withdrawParam
                });

              case 3:
                resp = _context6.sent;
                _this7$$zgKaihu$$conv = _this7.$zgKaihu.$convertResp(resp), success = _this7$$zgKaihu$$conv.success, data = _this7$$zgKaihu$$conv.data;

                if (success && data.success) {
                  _this7.sms.visible = false;
                  _this7.accTradeId = data.accTradeId;

                  if (_this7.accType === 2) {
                    //招行提现 直接跳到结果页查询
                    _this7.$emit('resultHandler', data.accTradeId);
                  } else if (_this7.accType === 5) {
                    //财付通提现 扫码轮询
                    if (data.qrCodeInfo) {
                      _this7.cftScanInit(data.qrCodeInfo);
                    } else {
                      _this7.$message.warning('获取提现二维码失败');
                    }
                  }
                } else {
                  data && data.errorMsg && _this7.$message.error(data.errorMsg);
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    cftScanInit: function cftScanInit(qrCodeInfo) {
      this.cftScan.qrCodeInfo = qrCodeInfo;
      this.cftScan.visible = true;
      this.cftScanLoop();
    },
    cftScanLoop: function cftScanLoop() {
      var _this8 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var resp, _this8$$zgKaihu$$conv, success, data;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _this8.$zgKaihu.$get('paycore.service.getAccTradeResult', {
                  accTradeId: _this8.accTradeId
                }, {
                  notNeedLoading: true
                });

              case 3:
                resp = _context7.sent;
                _this8$$zgKaihu$$conv = _this8.$zgKaihu.$convertResp(resp), success = _this8$$zgKaihu$$conv.success, data = _this8$$zgKaihu$$conv.data;

                if (success) {
                  if (data.accTradeVO && data.accTradeVO.status !== 1) {
                    _this8.$message.success('扫码成功');

                    _this8.cftScanCloseHandler();

                    _this8.$emit('resultHandler', _this8.accTradeId);
                  } else {
                    //没结果继续轮询
                    _this8.cftScan.timer = setTimeout(_this8.cftScanLoop, 2000);
                  }
                } else {
                  _this8.$message.warning('轮询接口调用失败');
                }

                _context7.next = 11;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);

                _this8.$message.warning('轮询接口调用失败');

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, null, [[0, 8]]);
      }))();
    },
    //取消二维码轮询
    cftScanLoopClear: function cftScanLoopClear() {
      this.cftScan.timer && clearTimeout(this.cftScan.timer);
    },
    //手动关闭二维码
    cftScanCloseHandler: function cftScanCloseHandler() {
      this.cftScan.visible = false;
      this.cftScan.qrCodeInfo = {};
      this.cftScanLoopClear();
    },
    cftScanTenpayInitFail: function cftScanTenpayInitFail(_ref) {
      var _ref$msg = _ref.msg,
          msg = _ref$msg === void 0 ? '' : _ref$msg,
          _ref$errcode = _ref.errcode,
          errcode = _ref$errcode === void 0 ? '' : _ref$errcode;
      this.$message.warning('二维码生成失败');
    }
  }
});
// CONCATENATED MODULE: ./packages/account-withdraw/src/main.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mainvue_type_script_lang_js_ = (mainvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/account-withdraw/src/main.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_mainvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/account-withdraw/src/main.vue"
/* harmony default export */ var main = (component.exports);
// CONCATENATED MODULE: ./packages/account-withdraw/index.js


/* istanbul ignore next */

main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var account_withdraw = __webpack_exports__["default"] = (main);

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.filter");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.string.replace");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/kaihu-sms-code");

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptor");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.object.get-own-property-descriptors");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.function.name");

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = require("number-precision");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/utils/filters");

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/utils/debounce");

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

module.exports = require("zgkaihu/lib/cft-scan-dialog");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("regenerator-runtime/runtime");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.for-each");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/web.dom-collections.for-each");

/***/ }),

/***/ 99:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.parse-float");

/***/ })

/******/ });